import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-read-next',
  templateUrl: './read-next.component.html',
  styleUrls: ['./read-next.component.scss']
})
export class ReadNextComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
